
import { API } from '../../config/api';
import { GET } from '../../utils/apicalls';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './categoryManagement.css';

function CategoryManagement() {
    const [isLoading, setIsLoading] = useState(false);
    const [categoryData, setCategoryData] = useState<any>([]);
    const navigate = useNavigate();

    const fetchCategories = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.LISTING_GET_CATEGORY, {});
            setCategoryData(response?.data || []);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);



    return (
        <>
            <div className="category-container">
                <div className="category-wrapper">
                    <h1 className="category-title">Shope By Category</h1>
                    <br />
                    <br />
                    {isLoading ? (
                        <p className="loading-text">Loading...</p>
                    ) : (
                        <div className="category-list">
                            {categoryData.map((category: any, index: number) => (
                                <div key={index} className="category-card">
                                    <img
                                        src={category.categoryImage}
                                        alt={category.categoryTitle}
                                        className="category-image"
                                        onClick={() => navigate(`/category/${category.id}`)} />
                                    <h2 className="category-name">{category.categoryTitle}</h2>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div></>
    );
}

export default CategoryManagement;